import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgMoon = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M10.964 5.55a1 1 0 0 1 .25.997 5 5 0 0 0 6.239 6.238 1 1 0 0 1 1.247 1.247A7 7 0 1 1 9.967 5.3a1 1 0 0 1 .997.25'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgMoon)
export default ForwardRef
